@use "../../styles/screen-reader-only";

hp6-focus-trap {
  .hidden-focusable {
    @include screen-reader-only.screen-reader-only;
  }
}
